import { Pagination, Spin, Avatar, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import axiosInstance from "../config/axios-instance";
import { LoadingOutlined, UserOutlined } from "@ant-design/icons";
import "../components/AllClients/AllClient.scss";
import { Link, useLocation, useHistory } from "react-router-dom";
import company_placeholder from "../img/company_placeholder.png";
import { useSelector } from "react-redux";
import Head from "../components/Head";

const AllClients = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const history = useHistory();
  const { user } = useSelector((state: any) => state.auth);

  function useQueryy() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQueryy();

  const fetchClients = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/admin/companies?page=${query.get("page") || 1}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  const { isLoading, isError, data, error } = useQuery(
    ["companies", query.get("page")],
    () => fetchClients(),
    { keepPreviousData: true }
  );

  useEffect(() => {
    const resize: any = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [width]);

  return isLoading ? (
    <div className="loading_orders">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <div className="my_orders">
      <Head title="Orders" />
      <div className="container">
        <table className="table mt-2">
          <tbody>
            {data?.data.data.map((el: any, i: number) => (
              <tr key={i} style={{ height: "66px" }}>
                <td>
                  <div className="d-flex align-items-center">
                    <img
                      className="mr-3"
                      src={
                        el.logo
                          ? process.env.REACT_APP_STORAGE_URL + el.logo
                          : company_placeholder
                      }
                      width="30"
                    />
                    <p className="mb-0">{el.name}</p>
                  </div>
                </td>
                {user && user.role === "admin" && (
                  <td>
                    <Avatar.Group
                      maxCount={2}
                      size="large"
                      maxStyle={{
                        color: "#f56a00",
                        backgroundColor: "#fde3cf",
                      }}
                    >
                      {el.commercials.map((commercial: any) => (
                        <Tooltip
                          title={commercial.name}
                          key={commercial.id}
                          placement="bottom"
                        >
                          <Avatar
                            icon={
                              !commercial.avatar && (
                                <UserOutlined style={{ verticalAlign: 0 }} />
                              )
                            }
                            style={{
                              backgroundColor: !commercial.avatar
                                ? "#00468c"
                                : "inherit",
                            }}
                            src={
                              commercial.avatar
                                ? process.env.REACT_APP_STORAGE_URL +
                                  commercial.avatar
                                : ""
                            }
                          />
                        </Tooltip>
                      ))}
                    </Avatar.Group>
                  </td>
                )}
                <td align="center">
                  <Link to={`/all-clients/${el.id}/1`}>See details</Link>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={5}>
                <Pagination
                  defaultCurrent={1}
                  defaultPageSize={10}
                  total={data && data.data.total}
                  hideOnSinglePage
                  responsive
                  onChange={(page: any) =>
                    history.push(`/all-clients?page=${page}`)
                  }
                />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default AllClients;
